import { render, staticRenderFns } from "./removeData.vue?vue&type=template&id=00d746c6&"
import script from "./removeData.vue?vue&type=script&lang=js&"
export * from "./removeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports